import { Component, inject, input } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import type { EnvConfigBrand } from '@core/config-models';
import type { RichTextField } from '@sitecore-jss/sitecore-jss-angular';

import { CommodityOfferAlignment } from '../commodity-offers.model';

@Component({
  selector: 'wl-commodity-offer-header',
  templateUrl: './commodity-offer-header.component.html',
  styleUrls: [
    './commodity-offer-header.component.ed.scss',
    './commodity-offer-header.component.essent.scss',
  ],
})
export class CommodityOfferHeaderComponent {
  brand: EnvConfigBrand = inject(ENVIRONMENT_CONFIG).brand;

  readonly headerTitle = input<string>();
  readonly alignment = input.required<CommodityOfferAlignment>();
  readonly showBrandHeader = input(true);
  readonly redeliveryNotice = input<RichTextField>();
  readonly hasSolarPanels = input(false);
}
